// Shown when the bootstrap failed, so there is no user language yet.
export const T = {
  en_GB: { loadFailed: "Failed to load application data.", tryAgain: "Try again" },
  nb_NO: { loadFailed: "Kunne ikke laste applikasjonsdataene.", tryAgain: "Prøv igjen" },
} as const;
